import Slider from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import PropTypes from 'prop-types';
import './style.scss';

export default function ListStatus({ onChange, statusList, selectedStatus }) {
  const settings = {
    dots: false,
    infinite: false,
    initialSlide: 0,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    swipeToSlide: true,
    variableWidth: true,
  };

  function displayStatus(status) {
    if (status === '') {
      return 'All';
    } else {
      let str = status.split('_');
      str = str.map((item) => {
        return item.charAt(0).toUpperCase() + item.slice(1);
      });
      return str.join(' ');
    }
  }

  return (
  <div style={{width : '100%'}}>
    <Slider {...settings} className="slider-status">
      {statusList.map((status, i) => (
        <div
        onClick={() => onChange(status)}
        key={i}
        className={`status-item ${
          selectedStatus === status && 'status-item--active'
        }`}>
          <span>{displayStatus(status)}</span>
        </div>
      ))}
    </Slider>
  </div>
  );
}

ListStatus.propTypes = {
  onChange: PropTypes.func.isRequired,
  statusList: PropTypes.array,
  selectedStatus: PropTypes.string
};